import { render } from "./update-category-target.vue?vue&type=template&id=17578f3d&scoped=true"
import script from "./update-category-target.vue?vue&type=script&lang=js"
export * from "./update-category-target.vue?vue&type=script&lang=js"

import "./update-category-target.vue?vue&type=style&index=0&id=17578f3d&scoped=true&lang=less"

import exportComponent from "/home/www/jenkins/jenkins_home/workspace/yizhige_production/yizhige_admin_pro/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17578f3d"]])

export default __exports__